var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwapVertDownActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17724",
    d: "M9 3 5 6.99h3V14h2V6.99h3zm0 0L5 6.99h3V14h2V6.99h3z",
    style: {
      fill: "#cecfd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18556",
    d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99zm0 0V10h-2v7.01h-3L15 21l4-3.99z",
    style: {
      fill: "#3f54d9"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapVertDownActive);
export default __webpack_public_path__ + "static/media/swap-vert-down-active.4726ae446c7ac3dfb346cd0daf6dbb60.svg";
export { ForwardRef as ReactComponent };